import { useRef, useState } from "react";

//Options
//
// threshold -> % of element visible to trigger (0–1)
// Example: 0.5 = 50% visible
//
// rootMargin -> Expand/shrink detection area
// Example: "0px 0px -100px 0px"
//
// root -> Custom scroll container (default: viewport)
// Example: document.querySelector('#scroll-box')

const DEFAULT_OPTIONS: IntersectionObserverInit = { threshold: 0.1 };

export function useIsInView(options = DEFAULT_OPTIONS) {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const [isInView, setIsInView] = useState(false);

  const ref = (node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node) {
      const observer = new IntersectionObserver(([entry]) => {
        setIsInView(entry.isIntersecting);
      }, options);
      observer.observe(node);
      observerRef.current = observer;
    }
  };

  return { ref, isInView };
}
